<template>
  <div class="VB_Error VB_Error--404">
    <div>
      <h2>
        We couldn't find that
      </h2>
      <p>
        Unfortunately we couldn't find the file or client ID you are looking
        for. Please contact ViewMedica support if you reached this page through
        your ViewMedica product or account.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ViewmedicaBrochure404"
};
</script>
